import { clsx } from "../../node_modules/clsx/dist/clsx.js";
import { twMerge } from "../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const cn = (...classes) => twMerge(clsx(...classes));
export {
  cn
};
//# sourceMappingURL=common.utils.js.map
